module.exports = __webpack_public_path__ + "img/390.6b05ab51.jpg";